/* eslint-disable no-return-assign */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { TableRow, TableCell } from '@mui/material';
// components
import { LeadListPopup } from '../dialogPopUp';
// store
import { setAudienceData } from '../../redux/slices/audienceManager';
import { clearPopupLead, getLead } from '../../redux/slices/analytics';
import { dispatch, useSelector } from '../../redux/store';
// Hooks/constants/utils
import { useBoolean } from '../../hooks';
import { LeadLabelsForReports } from '../../constants/TableDataConst';
import { TableOrder, TableOrderBy } from '../../utils/allTableTab';
// styles
import { rowLeadCount } from '../../utils/legacyReportRows';
import { analyticsTableCell, analyticsTableFirstCellStyle, analyticsTablePriceCell, analyticsTableRowStyle } from '../../styles/analytics';

const SourceSummaryRow = ({ data }) => {
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { leads, dateRange } = useSelector((state) => state.analytics);
    const { sourceType } = useSelector((state) => state.schema);
    const [rowData, setRowData] = useState({
        status: '',
        categoryId: '',
        source: ''
    });

    const open = useBoolean();

    const tableOrder = TableOrder();
    const tableOrderBy = TableOrderBy();

    const handleRowClick = (data, status) => {
        setRowData({
            status,
            categoryId: '',
            source: data[0]
        });
        open.onTrue();
        dispatch(
            getLead({
                id: practiceId,
                status,
                limit: 10,
                offset: 0,
                order: tableOrder,
                orderId: tableOrderBy,
                startDate: dateRange?.startDate,
                endDate: dateRange?.endDate,
                source: data[0],
            })
        );
        const updatedCampaign = {
            recepient: {
                filters: {
                    created_at__range: [dateRange?.startDate, dateRange?.endDate],
                    lead_source__type__in: [data[0]],
                },
            },
        };
        if (status && status !== 'All') {
            updatedCampaign.recepient.filters = { ...updatedCampaign.recepient.filters, lead_treatments__status__in: [status] };
        }
        dispatch(setAudienceData(updatedCampaign));
    };

    const handlePagination = (data) => {
        dispatch(
            getLead({
                id: practiceId,
                categoryId: rowData.categoryId,
                status: rowData.status,
                limit: data.limit,
                offset: data.offset,
                order: data.order,
                orderId: data.orderId,
                startDate: dateRange?.startDate,
                endDate: dateRange?.endDate,
                source: rowData.source,
            })
        );
    };

    const handleClose = () => {
        open.onFalse();
        dispatch(clearPopupLead());
    };

    return (
        <TableRow hover sx={analyticsTableRowStyle}>
            <TableCell sx={analyticsTableFirstCellStyle}>
                {
                    sourceType?.filter((el) => el.value === data[0])?.[0]?.label
                }
            </TableCell>
            <TableCell sx={analyticsTableCell} onClick={() => handleRowClick(data, 'All')}>
                {rowLeadCount(data[1])}
            </TableCell>
            <TableCell sx={analyticsTableCell} onClick={() => handleRowClick(data, 'NEW')}>
                {data[1]?.filter((el) => el?.lead_treatments__status === 'NEW')[0]?.count_id || 0}
            </TableCell>
            <TableCell sx={analyticsTableCell} onClick={() => handleRowClick(data, 'CONSULTATION_BOOKED')}>
                {data[1]?.filter((el) => el?.lead_treatments__status === 'CONSULTATION_BOOKED')[0]?.count_id || 0}
            </TableCell>
            <TableCell sx={analyticsTableCell} onClick={() => handleRowClick(data, 'CONSULTATION_ATTENDED')}>
                {data[1]?.filter((el) => el?.lead_treatments__status === 'CONSULTATION_ATTENDED')[0]?.count_id || 0}
            </TableCell>
            <TableCell sx={analyticsTableCell} onClick={() => handleRowClick(data, 'TREATMENT_STARTED')}>
                {data[1]?.filter((el) => el?.lead_treatments__status === 'TREATMENT_STARTED')[0]?.count_id || 0}
            </TableCell>
            <TableCell sx={analyticsTableCell} onClick={() => handleRowClick(data, 'FAILED_TO_ATTEND_CONSULTATION')}>
                {data[1]?.filter((el) => el?.lead_treatments__status === 'FAILED_TO_ATTEND_CONSULTATION')[0]?.count_id || 0}
            </TableCell>
            <TableCell sx={analyticsTableCell} onClick={() => handleRowClick(data, 'CLOSED')}>
                {data[1]?.filter((el) => el?.lead_treatments__status === 'CLOSED')[0]?.count_id || 0}
            </TableCell>
            <TableCell sx={analyticsTablePriceCell}>
                £{data[1]?.reduce((total, currentValue) => total += currentValue?.sum_lead_treatments__custom_price, 0).toLocaleString() || 0}
            </TableCell>
            {open && <LeadListPopup
                open={open?.value}
                onClose={handleClose}
                type={'reportTableData'}
                updateLeadPage={(data) => handlePagination(data)}
                practiceId={practiceId}
                count={leads?.count}
                LeadLabelsForReports={LeadLabelsForReports}
                data={leads?.results}
                rowStatus={rowData?.status}
            />}
        </TableRow>
    );
};

SourceSummaryRow.propTypes = {
    data: PropTypes.any,
};

export default SourceSummaryRow;
